import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aeb959e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_5 = { class: "p-mt-2" }
const _hoisted_6 = { class: "table table-bordered table-hover" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "ACCOUNT TITLE AND EXPLANATION"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DEBIT"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "CREDIT")
], -1))
const _hoisted_8 = { class: "p-p-1" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "p-p-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { style: {"background-color":"#eee"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, " TOTAL ", -1))
const _hoisted_14 = { class: "p-p-1" }
const _hoisted_15 = { class: "p-p-1" }
const _hoisted_16 = { style: {"background-color":"#ccc"} }
const _hoisted_17 = {
  class: "p-p-1",
  colspan: "3"
}
const _hoisted_18 = { class: "p-mx-5" }
const _hoisted_19 = { class: "p-mx-5" }
const _hoisted_20 = { class: "p-mx-5" }
const _hoisted_21 = { class: "p-mx-5" }
const _hoisted_22 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1))
const _hoisted_24 = { class: "p-field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "OR", -1))
const _hoisted_27 = { class: "p-grid" }
const _hoisted_28 = { class: "p-col" }
const _hoisted_29 = { class: "p-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1))
const _hoisted_31 = { class: "p-col" }
const _hoisted_32 = { class: "p-field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1))
const _hoisted_34 = { class: "field" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Store Type", -1))
const _hoisted_36 = { class: "p-grid pt-3" }
const _hoisted_37 = { class: "p-col" }
const _hoisted_38 = { class: "p-field" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-success px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              class: "p-button-primary px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.storeName) + " Statement of General Journal", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (l, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: l }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(l.transactionEntries, (sub) => {
                return (_openBlock(), _createElementBlock("tr", { key: sub }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(["p-p-1", {'padding-left': sub.type == 'Credit'}])
                  }, _toDisplayString(sub.accountName), 3),
                  _createElementVNode("td", _hoisted_8, [
                    (sub.type == 'Debit')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.formatAmount(sub.amount)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    (sub.type == 'Credit')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatAmount(sub.amount)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              _createElementVNode("tr", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.sumTotalAmount(l.transactionEntries,'Debit'))), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.sumTotalAmount(l.transactionEntries,'Credit'))), 1)
              ]),
              _createElementVNode("tr", _hoisted_16, [
                _createElementVNode("td", _hoisted_17, [
                  _createTextVNode(" SNO : " + _toDisplayString(i+1) + " ", 1),
                  _createElementVNode("span", _hoisted_18, " Date : " + _toDisplayString(_ctx.formatDate(l.createdAt)) + " / " + _toDisplayString(_ctx.formatTime(l.createdAt)), 1),
                  _createElementVNode("span", _hoisted_19, " Source: " + _toDisplayString(l.generatedSource), 1),
                  _createElementVNode("span", _hoisted_20, " Narration: " + _toDisplayString(l.narration), 1),
                  _createElementVNode("b", _hoisted_21, "Store : " + _toDisplayString(l.branchName.name) + " (" + _toDisplayString(l.branchName.code) + ")", 1)
                ])
              ])
            ], 64))
          }), 128))
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_22, [
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.filterDates,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearForFilters())),
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.storeType,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.storeType) = $event)),
              options: _ctx.storeType,
              filter: true,
              optionLabel: "name",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}